module.exports = __webpack_public_path__ + "img/learningpath_thumbnail_logo.51d48baf.svg";